// extracted by mini-css-extract-plugin
module.exports = {"avatar":"-DVsxUFEJFetd4cWN49fHQ==","userName":"VT7d0rgy43N72C4785aLKg==","menu":"vi3vGOWC6dT5012OQhwZNw=="};